export const REPO_OWNER = 'facebook';
export const REPO_NAME = 'react';
export const OPEN = '711';
export const CLOSED = '10,811';